module.exports = __webpack_public_path__ + "static/media/wevva-background.0b25c35c.jpg";